import React from "react";
import { useAuth } from "react-oidc-context"; // Import the authentication hook
import { BrowserRouter as Router, Routes, Route, Link, } from "react-router-dom"; // Import routing components
import Callback from "./Callback"; // Callback component
import Home from "./Home"; // Callback component
import Dashboard from "./Dashboard"; // Secure page after login
import OrderVerification from "./OrderVerification";
import OrderDetails from "./OrderDetails";
import './App.css'; // Import CSS for styling
import PrivateRoute from './PrivateRoute';

function App() {
  const auth = useAuth();

  // Logout redirect
  const signOutRedirect = () => {
    auth.removeUser();
    const clientId = "7p4djil0soacn5foe6tgqc00cr";
    const logoutUri = "https://employee.currentix.de"; // Change this to your logout URL
    const cognitoDomain = "https://currentix-employee.auth.eu-central-1.amazoncognito.com";
    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
  };

  // If loading or error state, show corresponding messages
  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  if (auth.error) {
    return <div>Error: {auth.error.message}</div>;
  }

  // Main UI when authenticated or not
  return (
    <Router>
      <div className="container">
        <div className="main-content">
          <Routes>
            <Route path="/callback" element={<Callback />} />
            <Route path="/" element={<Home />} />
            <Route path="/dashboard" element={<PrivateRoute element={<Dashboard />} />} />
            <Route path="/order-verification" element={<PrivateRoute element={<OrderVerification />} />} />
            <Route path="/order-details/:idOrder" element={<PrivateRoute element={<OrderDetails />} />} />
          </Routes>
        </div>

        <div className="navbar">
          <nav>
            <ul>
              {auth.isAuthenticated && (
                <li>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
              )}
              {auth.isAuthenticated && (
                <li>
                  <Link to="/order-details">Orderdetails</Link>
                </li>
              )}
              {auth.isAuthenticated && (
                <li>
                  <Link to="/order-verification">Order Verification</Link>
                </li>
              )}
              <li>
                {auth.isAuthenticated ? (
                  <button onClick={signOutRedirect}>Logout</button>
                ) : (
                  <button onClick={() => auth.signinRedirect()}>Login</button>
                )}
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </Router>
  );
}

export default App;
